<template>
  <div class="wrapper">
    <slot />
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.wrapper {
  height: fit-content;
  margin: 0 auto;
  padding: 0 4.675rem;
  &.fluid {
    height: fit-content;
    max-width: 100%;
  }
  @include respond-below(md) {
    padding-block: 0.6rem;
    padding-inline: 0.6rem;
  }
}
</style>
